
let GLOBAL_DECIMAL_DIGITS = 2;

export enum RoundingType {
  RoundOff,
  RoundUp,
  RoundDown,
  Truncate,
}

export type CurrentBooking = any;

export function setGlobalDecimalDigits(digits:  number){
  GLOBAL_DECIMAL_DIGITS = digits;
}

export function number_format(input: number, decimalDigits?: number, roundingType: RoundingType | string = RoundingType.RoundOff): string{
  if(!input){
    input = 0;
  }
  if(typeof input === 'string'){
    input = parseFloat(input);
    if(!input){
      input = 0;
    }
  }

  if(!decimalDigits){
    decimalDigits = GLOBAL_DECIMAL_DIGITS;
  }

  const v = number_rounding(input, decimalDigits, roundingType as any);
  const str = v.toFixed(decimalDigits);
  const parts = str.split('.');
  return parts[0].replace(new RegExp(`\\B(?=(\\d{3})+(?!\\d))`, 'g'), ',') + '.' + parts[1];
}

export function number_rounding(input: number, decimalDigits?: number, roundingType: string = RoundingType[RoundingType.RoundOff]): number {
  if(!input){
    return 0;
  }
  var result = input;
  if(!decimalDigits){
    decimalDigits = GLOBAL_DECIMAL_DIGITS;
  }
  var decimalplaces = Math.pow(10, decimalDigits);

  switch (roundingType) {
    case RoundingType[RoundingType.RoundOff]:
      result = Math.round(result * decimalplaces) / decimalplaces;
      break;
    case RoundingType[RoundingType.RoundUp]:
      result = Math.ceil(result * decimalplaces) / decimalplaces;
      break;
    case RoundingType[RoundingType.RoundDown]:
      result = Math.floor(result * decimalplaces) / decimalplaces;
      break;
    case RoundingType[RoundingType.Truncate]:
      result = Math.trunc(result);
      break;
  }
  return result;
}

export function validate_str_to_amount(value: string){
  if(value && !/^[0-9\.]+$/i.test(value)){
    return false;
  }

  if(value && value.trim()){
    value = value.trim();
    if(value.split('').filter(e => e === '.').length > 1){
      return false;
    }
    const val = parseFloat(value);
    if(!val) return false; 
  }

  return true;
}

export function number_round2(num: number): number {
  return number_rounding(num);
}

export function sum2(num1: number, num2: number): number{
  return number_round2(num1 + num2);
}

export function res_no_of(booking: CurrentBooking){
  if(!booking) return "";
  return booking.bookingNumber;
}

export function arr_sort_asc(arr: any[], field: string, fieldType?: 'number' | 'string'| 'date'){
  if(fieldType === 'date'){
    arr.sort((a, b) => (new Date(a[field]).getTime() - (new Date(b[field]).getTime())));
    return;
  }
  arr.sort((a, b) => a[field] - b[field]);
}

export function arr_sort_desc(arr: any[], field: string, fieldType?: 'number' | 'string'| 'date'){
  if(fieldType === 'date'){
    arr.sort((a, b) => (new Date(b[field]).getTime() - (new Date(a[field]).getTime())));
    return;
  }
  arr.sort((a, b) => b[field] - a[field]);
}

export function convertQueryStringToObject(queryString: string): object {
  if(!queryString) return {};
  const params = new URLSearchParams(queryString);
  const result: { [key: string]: string } = {};

  params.forEach((value, key) => {
    result[key] = value;
  });

  return result;
}

export function str_capitalize(input: string): string {
  // Split the input string into words
  const words = input.split(' ');

  // Capitalize the first letter of each word
  const capitalizedWords = words.map(word => {
    if (word.length === 0) {
      return '';
    } else if (word.length === 1) {
      return word.charAt(0).toUpperCase();
    } else {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }
  });

  // Join the capitalized words back into a single string
  const result = capitalizedWords.join(' ');

  return result;
}

export function identifier_valid(str: string): boolean{
  if(str && str !== "0"){
    return true;
  }

  return false;
}

export function is_url(str: string): boolean{
  if(!str){
    return false;
  }

  return /(https|http):\/\//i.test(str);
}